module.exports = __webpack_public_path__ + "static/media/lutron_blue_circle.d16bc0ad.png";